<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getFamilysupports () {
    //   this.$store.dispatch('getFamilysupports')
    // },

    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilysupports()
      vm.getUsersSelect()
      vm.getTags()
      vm.getCompanies()
      vm.getOffices()
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Familysupports.vue?4437eadb